export function getDefaultHostname({
  from,
  to,
  hostname,
  defaultVal,
}: {
  from: string;
  to: string;
  hostname: string;
  defaultVal: string;
}): { originHostname: string | null; redirectHostname: string } {
  const regExp = new RegExp(`${from}`);
  const match = hostname.match(regExp);

  if (!match) return { originHostname: null, redirectHostname: defaultVal };

  const replaced = to
    .replace("{1}", match[1] || "")
    .replace("{2}", match[2] || "")
    .replace("{3}", match[3] || "");

  const redirectHostname = (() => {
    if (replaced.startsWith(".")) return replaced.slice(1);

    return replaced;
  })();

  return { originHostname: hostname, redirectHostname };
}
